import React from 'react';

export const Certification = ({certifications}) => {
    return (
        <ul>
            {certifications.map((cer, index) => (
                <li key={index}>
                    <span className="date">{cer.date}</span><br/>
                    <span className="title">{cer.title}</span><br/>
                    <span className="description">{cer.description}</span>
                </li>
            ))}
        </ul>
    );
};